
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRouter } from "vue-router";
import { I18nUtils } from "@/sea/utils/I18nUtils";
import LightAlert from "@/sea/components/alerts/LightAlert.vue";
import { getProductCategoryRequest } from "@/sea/apis/ProductCategoriesService";

export default defineComponent({
  name: "productCategory",
  components: { LightAlert },
  props: {
    id: Number,
  },
  setup(props) {
    const router = useRouter();

    const id = props.id ?? 0;
    const { errorRef, productCategoryRef, getProductCategory } =
      getProductCategoryRequest();
    const loadingRef = ref(false);

    const fetchProductCategory = async (id: number) => {
      loadingRef.value = true;
      await getProductCategory(id);
      loadingRef.value = false;
    };

    onMounted(async () => {
      setCurrentPageBreadcrumbs(
        "sea.pages.productCategory.title",
        [
          "sea.aside.categories.product.title",
          "sea.pages.productCategories.title",
        ],
        ["", router.resolve({ name: "productCategories" }).path]
      );
      await fetchProductCategory(id);
    });

    return {
      I18nUtils,
      loadingRef,
      productCategoryRef,
      errorRef,
    };
  },
});
